'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var MessageLoader = _interopDefault(require('@zillow/message-loader'));
var isLocalStorageSupported = require('@zillow/is-local-storage-supported');

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

/**
 * Get GA data from tracker
 * @returns {Object}
 */
/**
 * Removes event listener. Complements listen function.
 * @kind function
 * @param {String}   eventName
 *                     name of custom event to be removed
 * @param {Function} eventCallback
 *                     callback to be executed on event dispatch
 * @param {Element}  eventTarget
 *                     target dispatching event - defaults to window
 */

var ignore = function ignore(eventName, eventCallback) {
  var eventTarget = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
  // useCapture false as no optimiziation around event dispatching exists
  eventTarget.removeEventListener(eventName, eventCallback, false);
};
/**
 * Custom event listener.
 * @kind function
 * @param {String}   eventName
 *                     name of custom event to be listened to
 * @param {Function} eventCallback
 *                     callback to be executed on event dispatch
 * @param {Element}  eventTarget
 *                     target dispatching event - defaults to window
 */

var listen = function listen(eventName, eventCallback) {
  var eventTarget = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
  // useCapture false as no optimiziation around event dispatching exists
  eventTarget.addEventListener(eventName, eventCallback, false);
};
var hasClass = function hasClass(element, cls) {
  return element && element.classList && element.classList.contains(cls);
};

var AB_NAME = 'ADT_PROGRESSIVE_MESSAGE';
var CONTROL_TREATMENT = 'CONTROL';
var EXPERIMENT_ID = 'MOBILE_APP_UPSELL';
var APP_UPSELL_DISMISS = 'APP_UPSELL_DISMISS_X';
var APP_UPSELL_PAGEVIEW = 'ACQ_PAGE_VIEW';
var APP_UPSELL_ORIGINATING_REFERRER = 'ACQ_ORIG_REFERRER';
var DISMISS_DURATION = 24 * 60 * 60 * 14 * 1000; // number of milliseconds to wait - currently 14 days

var HDP_BODY_CLASS = 'hdp-double-scroll-layout';
var SEARCH_BODY_CLASS = 'mobile-search-page';
var SEARCH_PAGE_TYPE = 'Search';
var HDP_PAGE_TYPE = 'HDP';
var OTHER_PAGE_TYPE = 'Other';

var localStorageSupported = isLocalStorageSupported.isLocalStorageSupported();
var sessionStorageSupported = isLocalStorageSupported.isSessionStorageSupported();

var MessageLoaderWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MessageLoaderWrapper, _React$Component);

  function MessageLoaderWrapper(props) {
    var _this;

    _classCallCheck(this, MessageLoaderWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MessageLoaderWrapper).call(this, props));
    _this.handlePageNavigation = _this.handlePageNavigation.bind(_assertThisInitialized(_this));
    _this.updateSessionPageViews = _this.updateSessionPageViews.bind(_assertThisInitialized(_this));
    var sessionPageViews = _this.sessionPageViews;
    var pageViews = sessionPageViews === null ? 1 : sessionPageViews + 1;
    _this.state = {
      pageViews: sessionStorageSupported ? pageViews : null
    };

    _this.updateSessionPageViews(pageViews);

    _this.originatingReferrer = document.referrer;
    return _this;
  }

  _createClass(MessageLoaderWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addPageNavigationListeners();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      ignore('UpdatedZPIDSelection', this.handlePageNavigation, document);
    }
  }, {
    key: "handlePageNavigation",
    value: function handlePageNavigation() {
      var _this2 = this;

      var pageViews = this.state.pageViews;

      if (pageViews === null) {
        return;
      }

      pageViews = pageViews + 1;
      var callback = this.updateSessionPageViews;
      var timestamp = Date.now();
      this.setState({
        pageViews: pageViews,
        pageLoadTimeStamp: timestamp
      }, function () {
        callback(_this2.state.pageViews);
      });
    }
  }, {
    key: "addPageNavigationListeners",
    value: function addPageNavigationListeners() {
      listen('UpdatedZPIDSelection', this.handlePageNavigation, document);
    }
  }, {
    key: "shouldShow",
    value: function shouldShow(timeStamp, duration) {
      if (timeStamp) {
        return Date.now() - timeStamp > duration;
      }

      return true;
    }
  }, {
    key: "updateSessionPageViews",
    value: function updateSessionPageViews(views) {
      this.sessionPageViews = views;
    }
  }, {
    key: "getPageName",
    value: function getPageName() {
      var body = window.document.body;
      var isSearchPage = hasClass(body, SEARCH_BODY_CLASS);
      var isHDPPage = hasClass(body, HDP_BODY_CLASS);

      if (isSearchPage) {
        return SEARCH_PAGE_TYPE;
      } else if (isHDPPage) {
        return HDP_PAGE_TYPE;
      }

      return OTHER_PAGE_TYPE;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          treatment = _this$props.treatment,
          forceTreatment = _this$props.forceTreatment;
      var _this$state = this.state,
          pageViews = _this$state.pageViews,
          pageLoadTimeStamp = _this$state.pageLoadTimeStamp;
      var loaderProps = {
        pageView: pageViews,
        // if sessionStorage is not suppported this will be null
        abConfig: [AB_NAME, treatment],
        experimentId: EXPERIMENT_ID,
        referrer: this.originatingReferrer,
        pageName: this.getPageName(),
        reloadTimeStamp: pageLoadTimeStamp
      };

      if (forceTreatment !== CONTROL_TREATMENT) {
        loaderProps.forceMessageName = forceTreatment;
      }

      if (this.shouldShow(this.timestamp, DISMISS_DURATION) || forceTreatment !== CONTROL_TREATMENT) {
        return React.createElement("div", null, React.createElement(MessageLoader, loaderProps));
      }

      return React.createElement("div", null);
    }
  }, {
    key: "timestamp",
    get: function get() {
      return localStorageSupported ? localStorage.getItem(APP_UPSELL_DISMISS) : null;
    },
    set: function set(timeStamp) {
      if (localStorageSupported) {
        localStorage.setItem(APP_UPSELL_DISMISS, timeStamp);
      }
    }
  }, {
    key: "originatingReferrer",
    get: function get() {
      return sessionStorageSupported ? sessionStorage.getItem(APP_UPSELL_ORIGINATING_REFERRER) : null;
    },
    set: function set(referer) {
      if (sessionStorageSupported && this.originatingReferrer === null) {
        sessionStorage.setItem(APP_UPSELL_ORIGINATING_REFERRER, referer);
      }
    }
  }, {
    key: "sessionPageViews",
    get: function get() {
      var views = sessionStorageSupported ? sessionStorage.getItem(APP_UPSELL_PAGEVIEW) : null;

      if (views !== null) {
        return parseInt(views, 10);
      }

      return views;
    },
    set: function set(views) {
      if (sessionStorageSupported) {
        if (views === null) {
          sessionStorage.removeItem(APP_UPSELL_PAGEVIEW);
        } else {
          sessionStorage.setItem(APP_UPSELL_PAGEVIEW, views);
        }
      }
    }
  }]);

  return MessageLoaderWrapper;
}(React.Component);

MessageLoaderWrapper.propTypes = {
  treatment: PropTypes.string,
  forceTreatment: PropTypes.string
};
MessageLoaderWrapper.defaultProps = {
  treatment: CONTROL_TREATMENT,
  forceTreatment: CONTROL_TREATMENT
};

module.exports = MessageLoaderWrapper;



//////////////////
// WEBPACK FOOTER
// ./~/@zillow/app-upsell-loader/lib/index.js
// module id = 485
// module chunks = 1